import CircleAlertSvg from '@assets/images/svg/circle-alert.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleAlertIconProps {
  size?: number;
  color?: string;
}

export function CircleAlertIcon({ size = 24, color = '#4D4D4D' }: CircleAlertIconProps) {
  return (
    <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
      <CircleAlertSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CircleAlertIcon;